import { render, staticRenderFns } from "./do_homework.vue?vue&type=template&id=6b38bb86&scoped=true&"
import script from "./do_homework.vue?vue&type=script&lang=js&"
export * from "./do_homework.vue?vue&type=script&lang=js&"
import style0 from "./do_homework.vue?vue&type=style&index=0&id=6b38bb86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b38bb86",
  null
  
)

export default component.exports